import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button  from '../../../common/components/button';

import { requestAlbumListForSelection } from '../../actions/album-actions';

import ContentAwareContainer from '../../../common/components/content-aware-container';

class SelectAlbumContent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedAlbumId: -1,
			albumRequestSatisfied: true
		};

		this.selectAlbum = this.selectAlbum.bind(this);
		this.albumSelectionChanged = this.albumSelectionChanged.bind(this);
		this.loadAdditionalItems = this.loadAdditionalItems.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (this.props.albums && prevProps.albums.length !== this.props.albums.length) {
			this.setState({ albumRequestSatisfied: true });
		}

		if (!prevProps.visible && this.props.visible) {
			this.loadAdditionalItems();
		}
	}

	loadAdditionalItems() {
		if (!this.props.visible) return;
		if (this.state.conditionIsSatified) return;

		const { requestAlbums, albums } = this.props;
		requestAlbums(albums.length);
		this.setState({ albumRequestSatisfied: false });
	}

	selectAlbum() {
		const { selectAlbum, onClose } = this.props;
		selectAlbum(this.state.selectedAlbumId);
		onClose();
	}

	albumSelectionChanged(evt) {
		this.setState({ selectedAlbumId: evt.target.value });
	}

	render() {
		const { albums } = this.props;

		return (
			<div>
				<ContentAwareContainer
					className="album-select-item-container"
					onNearBottom={this.loadAdditionalItems}
					conditionIsSatified={!this.state.albumRequestSatisfied}
					computeHeight={false}
				>
					{albums.map(album => {
						return (
							<div className="album-select-item" key={`album.select.${album.id}`}>
								<div>
									<input
										type="radio"
										className="album-select-radio"
										name="album-select"
										id={`album.select.${album.id}`}
										value={album.id}
										onChange={this.albumSelectionChanged}
									/>
								</div>
								<div className="album-select-label">
									<label htmlFor={`album.select.${album.id}`}>
									<div style={{ background: `url('${ album.thumbnails ? album.thumbnails[0] : ''}')` }} className="album-select-album-icon" />
										<div>{album.title && album.title.length >= 1 ? album.title : <i>(Unnamed album)</i>}</div>
									</label>
								</div>
							</div>
						);
					})}
				</ContentAwareContainer>
				<div className="btn-dialog-container">
                    <Button buttonStyle="primary" className="btn-dialog" buttonLabel="Select" onClick={this.selectAlbum} disabled={this.state.selectedAlbumId === -1} />
					<Button buttonStyle="secondary" className="btn-dialog" buttonLabel="Cancel" onClick={this.props.onClose} />
				</div>
			</div>
		);
	}
}

SelectAlbumContent.propTypes = {
	albums: PropTypes.object,
	requestAlbums: PropTypes.func,
	selectAlbum: PropTypes.func,
	onClose: PropTypes.func.isRequired,
	max: PropTypes.number,
	visible: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
	return {
		albums: state.albumList.albums,
		max: state.albumList.max
	};
};

const mapDispatchToProps = dispatch => {
	return {
		requestAlbums: (offset = 0) => requestAlbumListForSelection(dispatch, offset)
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectAlbumContent);



// WEBPACK FOOTER //
// ./src/album-view/components/dialog/select-album-content.jsx